import { Badge } from "antd";
import { isEventUpcoming } from "./common";


export const  itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a><i className="la la-angle-left" ></i></a>;
    }
    if (type === "next") {
      return <a><i className="la la-angle-right" ></i></a>;
    }
    return originalElement;
  };

 export const handlePageChange = (pagination, filters, sorter, pageSettings) => {
    console.log(pagination, filters, sorter, "LLLLLL")
    let page = pagination.current
    const offset = pagination.current * pagination.pageSize - pagination.pageSize;
    const limit = pagination.pageSize;
    const params = {};
    console.log(pagination.pageSize , pageSettings?.pageSize, "HEREEEEEEEEEEE")

    if (sorter?.hasOwnProperty("column")) {
      params.order = { field: sorter.field, dir: sorter.order };
      if((pageSettings?.sortType !== sorter.order) || (pageSettings?.sortBy !== sorter.field) ){
        page = 1
      }
    }
    if(pagination.pageSize !== pageSettings?.pageSize){
      page = 1
    }
  
    console.log(offset,limit, params,pagination.current , "LLLL" )
    return{
      ...pageSettings,
      pageSize: limit,
      page,
      sortType: sorter?.order ,
      sortBy: sorter?.field

    }

  };


  export const defaultPagination = {
    pageSize: 50,
    total: 0,
    page:1,
    sortType: "",
    sortBy: ""
  }
  export const pageSizeOptions = ['50', '100', '200', "500"]




  export const CustomRow = (props) => {
    const { children, ...restProps } = props;
    const anniversaryStatus = isEventUpcoming(props?.record?.employment?.employment_date);
  
    return (
      <>
     
      {
        props?.record?.is_celeb_birthday &&
        <Badge.Ribbon 
      text={ "Birthday 🎉"} 
      color={"green"}
      placement={"start"}
      size={"small"}
      style={{ zIndex: 1 , position: 'absolute', top: 0, left: -8 }}
    >
      <span></span>
    </Badge.Ribbon>
      }
      {
        anniversaryStatus  &&
        <Badge.Ribbon 
      text={ "Anniversary 🎉"} 
      color={"yellow"}
      placement={"start"}
      size={"small"}
      style={{ zIndex: 1 , position: 'absolute', top: props?.record?.is_celeb_birthday ? 25 : 0, left: -8 }}
    >
      <span></span>
    </Badge.Ribbon>
       }
      
    <tr
    {...restProps}
    style={{
      backgroundColor: '#f6f6f6',
      cursor: 'pointer',
    }}
    onClick={() => console.log('Row clicked:', props['data-row-key'])}
  >
    {children}
  </tr>
  </>
    );
  };